import { RHFRadioGroup } from '@/components/form/rhf-radio'
import { useCartStore } from '@/store'
import { useEffect } from 'react'
import { Control } from 'react-hook-form'

type Props = {
  control: Control<IFormCheckout, any> | any
  setPaymentMethod: (method: string) => void
  paymentMethod: string
}

export const PaymentMethod = ({ control, paymentMethod, setPaymentMethod }: Props) => {
  const { cartData } = useCartStore()
  const listPayment = cartData?.available_payment_methods

  useEffect(() => {
    if (listPayment?.length) {
      setPaymentMethod(listPayment[0]?.code)
    }
  }, [listPayment, setPaymentMethod])

  // const paymentMethodRender = () => {
  //   return (
  //     <RadioGroup>
  //       <Grid container spacing={1} columns={24}>
  //         {listPayment?.map((item, index) => {
  //           return (
  //             <Grid
  //               size={{
  //                 xs: 24,
  //               }}
  //               key={index}
  //             >
  //               <FormControlLabel
  //                 value={item?.code}
  //                 control={<Radio />}
  //                 className="flex w-full cursor-pointer items-center gap-2 rounded-lg border border-gray-200 px-2"
  //                 label={
  //                   <div className="flex h-fit w-full items-center gap-2">
  //                     {item?.logo && <Image src={item?.logo} alt="" width={24} height={18} />}
  //                     <span className="flex-1">{item?.title}</span>{' '}
  //                     {isPending && paymentMethod === item?.code && <LoddingIcon />}
  //                   </div>
  //                 }
  //               />
  //             </Grid>
  //           )
  //         })}{' '}
  //       </Grid>
  //     </RadioGroup>
  //   )
  // }
  if (!listPayment?.length) return <></>
  return (
    <>
      <RHFRadioGroup
        control={control}
        name="payment"
        options={listPayment?.map((el) => ({ label: el?.title, value: el?.code, type: 'payment' }))}
        defaultValue={listPayment?.[0]?.code}
        // customRender={paymentMethodRender}
        className="w-full"
        value={paymentMethod}
        onChange={(e) => {
          setPaymentMethod(e.target.value)
        }}
      />{' '}
    </>
  )
}
